<template>
  <b-nav-item class="user-dropdown" v-if="isAuthenticated">
    <div class="menu-container">
      <button class="menu-button" @click="toggleUserMenu">
        <img
          :src="getUserDetails.profile_photo"
          v-if="getUserDetails.profile_photo"
        />
        <img src="/img/user-placeholder.png" v-else />
        <span class="title">{{ getUserDetails.name }}</span>
      </button>

      <div class="menu-dropdown">
        <div class="content">
          <ul>
            <li @click="menuLinkClick" v-if="getUserRole === 'student'">
              <b-link
                :to="{
                  path: '/student/dashboard',
                  query: { role: getUserRole }
                }"
              >
                <font-awesome-icon icon="th" />
                Dashboard</b-link
              >
            </li>
            <li @click="menuLinkClick" v-if="getUserRole === 'teacher'">
              <b-link :to="{ path: '/admin' }">
                <font-awesome-icon icon="th" />
                Dashboard</b-link
              >
            </li>
            <li
              @click="menuLinkClick($event, '/student/my_courses')"
              v-if="getUserRole === 'student'"
            >
              <b-link>
                <font-awesome-icon icon="chalkboard-teacher" />
                My Courses</b-link
              >
            </li>
            <li
              @click="menuLinkClick($event, '/admin/courses')"
              v-if="getUserRole === 'teacher'"
            >
              <b-link>
                <font-awesome-icon icon="chalkboard-teacher" />
                My Courses</b-link
              >
            </li>
            <li
              @click="menuLinkClick($event, '/student/edit_profile')"
              v-if="getUserRole === 'student'"
            >
              <b-link>
                <font-awesome-icon icon="user-edit" />
                Edit profile</b-link
              >
            </li>
            <li
              @click="menuLinkClick($event, '/admin/edit-profile')"
              v-if="getUserRole === 'teacher'"
            >
              <b-link>
                <font-awesome-icon icon="user-edit" />
                Edit profile</b-link
              >
            </li>
            <li
              v-if="getUserRole === 'student'"
              @click="menuLinkClick($event, '/student/following')"
            >
              <b-link>
                <font-awesome-icon icon="user-plus" />
                Following</b-link
              >
            </li>
            <li
              v-if="getUserRole === 'teacher'"
              @click="menuLinkClick($event, '/admin/following-students')"
            >
              <b-link>
                <font-awesome-icon icon="user-plus" />
                Followers</b-link
              >
            </li>
            <li
              class="item"
              @click="menuLinkClick($event, '/admin/add-course')"
              v-if="getUserRole === 'teacher'"
            >
              <font-awesome-icon icon="plus-square" /> Add Course
            </li>
            <li
              @click="menuLinkClick($event, '/student/wishlist')"
              v-if="getUserRole === 'student'"
            >
              <b-link>
                <font-awesome-icon icon="heart" />
                Wishlist</b-link
              >
            </li>
            <li @click="toggleN" class="notification-link">
              <b-link>
                <font-awesome-icon icon="bell" />
                Notification
              </b-link>
            </li>
            <li @click="menuLinkClick($event, '/help')" class="help-link">
              <b-link>
                <font-awesome-icon icon="info-circle" />
                Help
              </b-link>
            </li>
            <hr />
            <li @click="logOut">
              <font-awesome-icon icon="sign-out-alt" />
              Logout
            </li>
          </ul>
        </div>
      </div>
    </div>
  </b-nav-item>
</template>

<script>
import { mapGetters } from "vuex";
import { commonFunctions } from "../../Commonjs/commonFunctions";
import { authenticationApi } from "../../services/authenticationApi";

export default {
  name: "user-menu",
  computed: {
    ...mapGetters("user", ["isAuthenticated", "getUserDetails", "getUserRole"])
  },
  methods: {
    toggleUserMenu(e) {
      e.preventDefault();
      var parent = document.querySelector(".menu-container");
      if (parent.classList.contains("open")) {
        parent.classList.remove("open");
      } else {
        parent.classList.add("open");
      }
    },
    menuLinkClick(e, routePath) {
      e.preventDefault();
      this.$router.push({
        path: routePath,
        query: {
          role: this.getUserRole
        }
      });
      e.target.closest(".menu-container").classList.remove("open");
    },
    toggleN(e) {
      commonFunctions.toggleNotification(e);
    },
    logOut() {
      authenticationApi.logOut().then(res => {
        // if (this.$route.meta.requiredAuth) {
        //   if (this.$route.path === "/course_subscription") {
        //     this.$router.back();
        //   } else {
        //     this.$router.push("/");
        //   }
        // }
        this.$router.push("/");
      });
    }
  }
};
</script>

<style scoped></style>
